import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedFileDownload } from '@eggplant/data-request'

interface Props {
  onSuccess: () => void
}

const DownloadSystemLogsRequest = ({
  onSuccess
}: Props) => {
  const url = `${AI_API_SERVICE}/system_logs`

  return (
    <AuthenticatedFileDownload
      fileType='application/zip'
      filename='eggplant_logs.zip'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default DownloadSystemLogsRequest
